"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingProfile = exports.BillingProfileProperties = exports.TaxStatusEnum = void 0;
var TaxStatusEnum;
(function (TaxStatusEnum) {
  /** Физическое лицо */
  TaxStatusEnum[TaxStatusEnum["Individual"] = 1] = "Individual";
  /** Самозанятый */
  TaxStatusEnum[TaxStatusEnum["SelfEmployed"] = 2] = "SelfEmployed";
  /** Индивидуальный предприниматель */
  TaxStatusEnum[TaxStatusEnum["Entrepreneur"] = 2] = "Entrepreneur";
  /** Юридическое лицо */
  TaxStatusEnum[TaxStatusEnum["Entity"] = 3] = "Entity";
})(TaxStatusEnum = exports.TaxStatusEnum || (exports.TaxStatusEnum = {}));
exports.BillingProfileProperties = ['version', 'country_id', 'region', 'city', 'address1', 'address2', 'postcode', 'tax_status', 'beneficiary', 'tax_number', 'invoice_email_enabled', 'invoice_email', 'agreement_signed', 'agreement_signed_at', 'bank', 'bank_bik', 'bank_address', 'bank_account_number', 'account_number', 'email', 'mobile_phone'];
var BillingProfile = /** @class */function () {
  function BillingProfile(values) {
    if (values === void 0) {
      values = {};
    }
    var properties = exports.BillingProfileProperties;
    var instance = this;
    properties.forEach(function (p) {
      if (p in values) {
        instance[p] = values[p];
      }
    });
    if ('agreement_signed_at' in values) {
      instance.agreement_signed_at = new Date(values.agreement_signed_at);
    }
  }
  return BillingProfile;
}();
exports.BillingProfile = BillingProfile;
